// extracted by mini-css-extract-plugin
export default {"titleWrapp":"TitlePart_titleWrapp__Wj4Hp","line":"TitlePart_line__A4iQM","moving":"TitlePart_moving__qSYZ2"};